class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        sidebarDrawer: this.querySelector('.menu-drawer'),
        overlay:  document.querySelector('body > .overlay'),
        sidebarDrawerButton: this.querySelectorAll('.button-close'),
        shopifySection: document.querySelector('#shopify-section-menu-drawer') || document.querySelector('#shopify-section-mega-menu-drawer')
      };
      this.closeTimeout = null;
      this.openTimeout = null;
      this.activeElement = null;
      document.querySelectorAll('.burger-menu').forEach(item => {
        item.setAttribute('aria-expanded', 'false');
        item.addEventListener('click', this.toggleDrawer.bind(this));
      });
      if (Shopify.designMode) {
        this.elements.shopifySection.addEventListener('shopify:section:select', this.openDrawer.bind(this));
        this.elements.shopifySection.addEventListener('shopify:section:deselect', this.closeDrawer.bind(this));
        this.elements.shopifySection.addEventListener('shopify:section:unload', this.openDrawer.bind(this))
        window.addEventListener('shopify:section:load', () => document.querySelectorAll('.burger-menu').forEach(item => item.addEventListener('click', this.toggleDrawer.bind(this))))
      }

      this.elements.sidebarDrawerButton.forEach(item => item.addEventListener('click', () => this.closeDrawer()));
      this.querySelectorAll('a[href]').forEach(item => item.addEventListener('click', () => this.closeDrawer({ restoreFocus: false })));
      document.addEventListener('keydown', this.handleKeyDown.bind(this), true);
      if (this.elements.overlay) {
        this.elements.overlay.addEventListener('click', () => {
          if (this.elements.sidebarDrawer.getAttribute('aria-hidden') === 'false') this.closeDrawer()
        });
      }
      window.addEventListener('resize', this.offsetHeight.bind(this))
    }

    getFocusableElements() {
      return getFocusableElements(this.elements.sidebarDrawer).filter(item => item.getClientRects().length > 0)
    }

    handleKeyDown(event) {
      if (this.elements.sidebarDrawer.getAttribute('aria-hidden') !== 'false') return

      if (event.key === 'Escape') {
        event.preventDefault()
        this.closeDrawer()
        return
      }

      if (event.key !== 'Tab') return

      const focusableElements = this.getFocusableElements()
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]
      if (!firstElement || !lastElement) return

      if (event.shiftKey && (document.activeElement === firstElement || !this.elements.sidebarDrawer.contains(document.activeElement))) {
        event.preventDefault()
        lastElement.focus()
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }

    toggleDrawer(event) {
      if (this.elements.sidebarDrawer.getAttribute('aria-hidden') === 'false') {
        this.closeDrawer();
        return;
      }

      this.openDrawer(event);
    }
  
    openDrawer(event) {
      window.clearTimeout(this.closeTimeout);
      window.clearTimeout(this.openTimeout);
      this.activeElement = event?.currentTarget || document.activeElement;
      this.elements.sidebarDrawer.removeAttribute('hidden')
      this.elements.sidebarDrawer.setAttribute('aria-hidden', 'false')
      this.openTimeout = window.setTimeout(() => {
        this.elements.sidebarDrawer.classList.add('open')
      }, 20)
      document.body.classList.add('hidden')
      document.body.classList.add('menu-drawer-open')
      if (this.elements.overlay) this.elements.overlay.classList.add('open')
      if(document.querySelector('[id$="menu-drawer"] .pinned-block') && document.querySelector('[id$="menu-drawer"] .nested-submenu')) {
        let bottomPadding = document.querySelector('[id$="menu-drawer"] .pinned-block').offsetHeight + 16
        this.elements.sidebarDrawer.setAttribute('style', `--height-pinned-block: ${bottomPadding}px`)
      }
      document.querySelectorAll('.burger-menu').forEach(item => item.setAttribute('aria-expanded', 'true'));

      this.getFocusableElements()[0]?.focus()
    }

    offsetHeight() {
      if(document.querySelector('[id$="menu-drawer"] .pinned-block') && document.querySelector('[id$="menu-drawer"] .nested-submenu')) {
        let bottomPadding = document.querySelector('[id$="menu-drawer"] .pinned-block').offsetHeight + 16
        this.elements.sidebarDrawer.setAttribute('style', `--height-pinned-block: ${bottomPadding}px`)
      }
    }
  
    closeDrawer({ restoreFocus = true } = {}) {
      window.clearTimeout(this.openTimeout);
      this.elements.sidebarDrawer.classList.remove('open')
      this.elements.sidebarDrawer.setAttribute('aria-hidden', 'true')
      if (this.elements.overlay) this.elements.overlay.classList.remove('open')
      document.body.classList.remove('hidden')
      document.body.classList.remove('menu-drawer-open')
      document.dispatchEvent(new CustomEvent('body:visible'));
      if (restoreFocus) {
        this.activeElement?.focus()
      } else if (this.elements.sidebarDrawer.contains(document.activeElement)) {
        document.activeElement.blur()
      }
      document.querySelectorAll('.burger-menu').forEach(item => item.setAttribute('aria-expanded', 'false'));
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = window.setTimeout(() => {
        if (!this.elements.sidebarDrawer.classList.contains('open')) {
          this.elements.sidebarDrawer.setAttribute('hidden', 'true')
        }
      }, 500)
    }
  }
  customElements.define('menu-drawer', MenuDrawer);
